<template>
  <div class="full-width-height">
    <div :class="{'split-alerts-container': alertsSources.length > 1}">
      <component
        v-for="(alertComponent, idx) in alertComponents"
        :key="idx"
        :is="alertComponent"
        :numOfAlertSources="alertsSources.length"
      ></component>
    </div>
  </div>
</template>

<script>
import ObjectAlerts from './ObjectAlerts.vue'
import ElopementAlerts from './ElopementAlerts.vue'
import { mapGetters, mapActions } from 'vuex'
import { DomainPreferences, AlertsSource } from '@/libraries/permissions/domainPreferences'
import SplitAlerts from '@/components/alerts/SplitAlerts'
import MaskAlerts from '@/components/alerts/MaskAlerts'

export default {
  name: 'EventsTimeline',
  components: {
    SplitAlerts,
  },
  data () {
    return {
      alertSourcesComponents: {
        [AlertsSource.FACES]: ElopementAlerts,
        [AlertsSource.OBJECTS]: ObjectAlerts,
        [AlertsSource.MASKS]: MaskAlerts,
      },
    }
  },
  computed: {
    ...mapGetters({
      currentDomain: 'currentDomain',
      preferences: 'preferences',
    }),
    alertComponents () {
      return this.alertsSources.map(alertSource => (this.alertSourcesComponents[alertSource]))
    },
    alertsSources () {
      let alertSources = this.preferences[DomainPreferences.ALERTS_SOURCE]
      return Array.isArray(alertSources) ? alertSources : [alertSources]
    },
    showElopementAlerts () {
      let alertSource = this.preferences[DomainPreferences.ALERTS_SOURCE]   // handles 'faces' and [...,'faces',...]
      if (Array.isArray(alertSource)) {
        return alertSource.includes(AlertsSource.FACES)
      }
      return alertSource === AlertsSource.FACES
    },
    showSplitAlertsView() {
      return this.preferences[DomainPreferences.ALERTS_SOURCE] === AlertsSource.SPLIT
    },
  },
  methods: {
    ...mapActions({
      refreshAlerts: 'elopementRisks/checkMostRecent',
    }),
  },
}
</script>

<style scoped>
.full-width-height {
  height: 100%;
  width: 100%;
}

.filter.banner {
  height: 7rem;
}

.sticky.header {
  background-color: rgba(0, 0, 0, 0);
  z-index: 10000;
  position: absolute;
  top: 5rem;
  left: 5rem;
  width: 90%;
  display: none;
}

.westchester {
  padding-top: 7rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow-y: auto;
}

.split-alerts-container {
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
@media only screen and (max-width: 1023px) {
  .split-alerts-container {
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
  }
}

</style>
